"use client";

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const dropdownItems = {
  COUNTRY: [
    "SOUTH AFRICA",
    "Botswana",
    "Cameroon",
    "Congo Democratic Republic (DRC)",
    "Cote-divorie",
    "Eswatini (Swaziland)",
    "Ethiopia",
    "Ghana",
    "Kenya",
    "Lesotho",
    "Malawi",
    "Mozambique",
    "Namibia",
    "Nigeria",
    "Rwanda",
    "Senegal",
    "Sierra Leone",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Tanzania",
    "Uganda",
    "Zambia",
    "Zimbabwe",
  ],
  REGION: [
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",


    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
  ],
  PROJECT: [
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
  ],

  CROP: [
    "MAIZE",
    "Apples",
    "Avocado",
    "Bananas",
    "Beans",
    "Cabbages",
    "Kale",
    "Mangoes",
    "Onions",
    "Passion Fruits",
    "Papaya",
    "Potatoes",
    "Strawberries",
    "Tomatoes",
    "Watermelon",
  ],
  LIVESTOCK: [
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
  ],
  DATA : [
    "PRODUCTION", "Revenue", "Inventory"],
};

const dropdownIcons = {
  COUNTRY:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744492909/Pin_alt_ioedjs.png",
    REGION:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
    CROP:
       "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
       DATA:
       "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
    PROJECT:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493133/image_fdtjzb.png",
    LIVESTOCK:
    "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493189/image_34_zwohkn.png",
};

const Dropdown = ({ label, items, type }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(items[0]);

  const icon = dropdownIcons[type];

  return (
<div className="flex flex-col w-full relative ">
  {/* Label */}
  <label className="md:text-[24px] font-bold text-[6px] text-black mb-1 md:mb-1">
    {label}
  </label>

  {/* Button + Icon Container */}
  <div className="flex relative z-20 w-fit">
    {/* Dropdown Button */}
    <button
      onClick={() => setIsOpen((prev) => !prev)}
      className="xl:w-[160px] lg:w-[140px] md:w-[55px] w-[40px] h-[15px] md:h-[47px] bg-[#2E453D] text-white font-bold flex justify-between items-center px-1 rounded-l-[5px]"
    >
      <span className="md:text-[14px] md:px-4 text-[4px] md:mt-0 mt-[2px]">{selected}</span>
    </button>

    {/* Icon Box */}
    <div
      className="w-[20px] h-[15px] md:h-[47px] md:w-[40px] bg-[#152C24] text-white flex justify-center items-center rounded-tr-[5px]   rounded-br-[5px]  -ml-2 z-30 cursor-pointer"
      onClick={() => setIsOpen((prev) => !prev)}
    >
      <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
        alt="expand"
        className="w-3 h-3 md:w-5 md:h-5"
      />
    </div>
  </div>

  {/* Dropdown List */}
  {/* Dropdown List */}
  <AnimatePresence>
    {isOpen && (
      <motion.ul
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        className="absolute top-full mt-1 left-0 z-50 md:w-[180px] w-[100px] bg-white/90 rounded-lg shadow-lg"
      >
        {items.map((item, index) => (
          <li
            key={index}
            onClick={() => {
              setSelected(item);
              setIsOpen(false);
            }}
            className="md:p-3 p-1 bg-[#CFD7D7] md:mt-1 md:text-[18px] text-[10px] rounded-md hover:bg-[#afafaf] cursor-pointer flex items-center"
          >
            <img src={icon} className="md:w-4 md:h-4 h-2 w-2 mr-2" alt="icon" />
            <span className="text-black">{item}</span>
          </li>
        ))}
      </motion.ul>
    )}
  </AnimatePresence>

  {/* Hint Text */}
  <p className="md:text-[14px] text-[6px] font-normal mt-1 text-black">
    Select {label}
  </p>

</div>


  
  );
};

const ReportsSection = () => {
  return (
    <div className="mb-10 mt-2 font-Inter w-full  mx-auto">
      <div className="md:mb-6 mb-3">
        <div className="text-left">
       
        </div>
        <div className="flex justify-between items-center ">
        <h2 className="text-[14px] md:text-[36px] font-bold text-[#FDBD26] ">
            Reports
          </h2>
<div className="flex md:space-x-6">
<div className="flex items-center   flex-shrink-0 md:mt-0 md:pr-0 pr-3 mt-3">
<p className="md:text-[16px] text-[5px] bg-[#2E453D] text-white md:px-4 px-2  md:w-[200px] md:py-[9px] py-[3px] md:rounded-tl-xl rounded-tl-md font-bold md:rounded-bl-xl rounded-bl-md whitespace-nowrap h-full">
  LOG IN
</p>

            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
              alt="Expand"
              className="w-[20px] h-[5px] md:h-[42px] md:w-[55px] md:flex hidden object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl bg-[#152C24] px-2 md:py-2"
            />
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
              alt="Expand"
              className="w-[20px] h-[13px] md:hidden py-[1px] flex md:h-[42.3px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#152C24] md:px-2 px-[2px] md:py-1"
            />
          </div>
          <div className="flex items-center flex-shrink-0 md:mt-0 md:pr-0 pr-3 mt-3">
          <p className="md:text-[16px] text-[5px] bg-[#FFBD26] text-white px-2 md:w-[220px] md:px-4 md:py-[9px] py-[3px] md:rounded-tl-xl rounded-tl-md font-bold md:rounded-bl-xl rounded-bl-md whitespace-nowrap h-full flex items-center justify-center">
  Subscribe for reports
</p>

            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
              alt="Expand"
              className="w-[20px] h-[5px] md:h-[42px] md:w-[55px] md:flex hidden object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl bg-[#152C24] px-2 md:py-2"
            />
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
              alt="Expand"
              className="w-[20px] h-[13px] md:hidden py-[1px] flex md:h-[42.3px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#152C24] md:px-2 px-[2px] md:py-1"
            />
          </div>
</div>
        </div>
      </div>

      <div className="flex justify-between items-center md:mb-5 mb-3">
        <h2 className="text-[14px] md:text-[36px] font-bold text-[#FDBD26] ">
        DASHBOARDS
          </h2>
          <div className="flex flex-row md:space-y-0 md:space-x-40 text-[#19253C] md:mt-10 mt-2 ">
          <div className="flex md:space-x-4 space-x-1 items-center">
            <h1 className="italic md:text-[20px]  text-[8px] font-normal">Opening Date</h1>
            <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745016720/image_1686_xak1hv.png" alt="calendar" className="md:w-[49px] md:h-[51px]  h-[15px]" />
          </div>
          <div className="flex md:space-x-4 space-x-1 items-center">
            <h1 className="italic md:text-[20px]  text-[8px] 1font-normal">Closing Date</h1>
            <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745016720/image_1686_xak1hv.png" alt="calendar" className="md:w-[49px] md:h-[51px] h-[15px]" />
          </div>
        </div>
        </div>
      <div className="flex md:gap-2 gap-[1px]   ">
    

        {Object.keys(dropdownItems).map((type) => {
          const customLabels = {
            Crop: "Crop Report",
            Livestock: "Livestock Report",
            Type: "Type of Report",
          };

          const displayLabel = customLabels[type] || type;

          return (
            <div key={type} className="w-full sm:w-auto">
              <Dropdown label={displayLabel} items={dropdownItems[type]} type={type} />
            </div>
          );
        })}
      </div>

    </div>
  );
};

export default ReportsSection;
